import { Address, AddressRequest } from '@nemuru-eng/js-api-client';

import { AddressSchemaType } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/schemas/AddressSchema';
import { getFormattedAddress } from '@/utils/getFormattedAddress';

export const AddressMap = {
  toDto: (address: AddressSchemaType): AddressRequest => ({
    geoLocateProviderAddress: {
      postalCode: address.postalCode,
      countryShortName: address.country,
      streetNumber: address.streetNumber,
      streetName: address.streetName,
      city: address.city,
      provinceLongName: address.province,
      countryLongName: address.countryLongName,
      ...(address.regionShortName && { regionShortName: address.regionShortName }),
      ...(address.region && { regionLongName: address.region }),
      ...(address.provinceShortName && { provinceShortName: address.provinceShortName }),
      ...(address.latitude &&
        address.longitude && {
          geoLocateCoordinates: {
            latitude: address.latitude,
            longitude: address.longitude,
          },
        }),
      geoLocateProviderAddress: address.address,
    },
    formattedAddress: getFormattedAddress(address),
    ...(address.floorNumber && { floorNumber: address.floorNumber }),
    ...(address.doorNumber && { doorNumber: address.doorNumber }),
    ...(address.building && { building: address.building }),
  }),

  toForm: ({
    floorNumber,
    doorNumber,
    building,
    formattedAddress: address,
    geoLocateProviderAddress: {
      streetName,
      streetNumber,
      postalCode,
      city,
      provinceLongName: province,
      provinceShortName,
      countryShortName: country,
      countryLongName,
      regionLongName: region,
      regionShortName,
      geoLocateCoordinates,
    },
  }: Address): Required<AddressSchemaType> => {
    return {
      address,
      streetName,
      streetNumber,
      postalCode,
      city,
      country,
      countryLongName,
      province: province ?? '',
      provinceShortName: provinceShortName ?? '',
      region: region ?? '',
      regionShortName: regionShortName ?? '',
      latitude: geoLocateCoordinates.latitude ?? 0,
      longitude: geoLocateCoordinates.longitude ?? 0,
      floorNumber: floorNumber ?? '',
      doorNumber: doorNumber ?? '',
      building: building ?? '',
    };
  },

  fromRepositoryToForm: ({
    floorNumber,
    doorNumber,
    building,
    formattedAddress: address,
    geoLocateProviderAddress: {
      streetName,
      streetNumber,
      postalCode,
      city,
      provinceLongName: province,
      provinceShortName,
      countryShortName: country,
      countryLongName,
      regionLongName: region,
      regionShortName,
      geoLocateCoordinates,
    },
  }: AddressRequest): Required<AddressSchemaType> => {
    return {
      address,
      streetName,
      streetNumber,
      postalCode,
      city,
      country,
      countryLongName,
      province,
      provinceShortName: provinceShortName ?? '',
      region: region ?? '',
      regionShortName: regionShortName ?? '',
      latitude: geoLocateCoordinates?.latitude ?? 0,
      longitude: geoLocateCoordinates?.longitude ?? 0,
      floorNumber: floorNumber ?? '',
      doorNumber: doorNumber ?? '',
      building: building ?? '',
    };
  },
};
